/** @format */

import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  input,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { HmfProgressRingComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@shared/data-access/services';

@Component({
  selector: 'common-gold-progress-ring',
  templateUrl: './gold-progress-ring.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HmfProgressRingComponent],
})
export class GoldProgressRingComponent implements OnInit, OnDestroy {
  salesTarget = 500;

  readonly currentSalesBalance = signal(0);
  readonly isGold = signal(false);

  readonly goldThruDate = input<string>('');
  readonly goldDescriptor = input<string>('');
  readonly size = input('large');

  private readonly ngUnsubscribe: Subject<void> = new Subject();
  private readonly store = inject(Store);

  ngOnInit() {
    this.store
      .selectDefined('PERSONAL_INFO')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((personalInfo) => {
        const currentYearSales = personalInfo.currentYearSales;
        this.isGold.set(personalInfo.isGold);

        if (!this.isGold()) {
          this.currentSalesBalance.set(currentYearSales);
        } else if (currentYearSales >= this.salesTarget) {
          this.currentSalesBalance.set(this.salesTarget);
        } else {
          this.currentSalesBalance.set(currentYearSales + this.salesTarget);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
